exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".card-body[data-v-54cdc180] {\n  position: relative;\n}\n.card-title[data-v-54cdc180] {\n  font-weight: 400;\n  margin-bottom: 15px;\n}\n.card-action[data-v-54cdc180] {\n  position: absolute;\n  top: 0;\n  right: 0;\n  padding: 0 5px 0 5px;\n}\n.card-action-click[data-v-54cdc180]:hover {\n  cursor: pointer;\n}\n", ""]);

// exports
